import React, { useState } from 'react';
import SPAButton from '@/components/admin/SysadminSPA/shared/SPAButton';
import SPADialog from '@/components/admin/SysadminSPA/shared/SPADialog';
import cn from '@/utils/cn';

interface DeleteNoteButtonProps {
  isDeleting: boolean;
  onConfirm: () => Promise<unknown>;
}

export const iconButtonClass = cn(
  'tw-inline-flex tw-h-8 tw-w-8 tw-items-center tw-justify-center tw-rounded-md tw-border-0 tw-bg-transparent tw-text-base',
  'tw-cursor-pointer tw-text-spa-tertiary hover:tw-bg-spa-bg-hover hover:tw-text-spa-heading',
  'focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-spa-accent',
);

const DeleteNoteButton = ({ isDeleting, onConfirm }: DeleteNoteButtonProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleConfirm = () => onConfirm().then(() => setIsOpen(false));

  return (
    <SPADialog open={isOpen} onOpenChange={setIsOpen}>
      <SPADialog.Trigger asChild>
        <button aria-label="Delete note" className={cn(iconButtonClass, 'hover:tw-text-spa-error')} type="button">
          <i aria-hidden="true" className="fa fa-trash-o" />
        </button>
      </SPADialog.Trigger>
      <SPADialog.Content size="sm">
        <SPADialog.Header>
          <SPADialog.Title>Delete this note?</SPADialog.Title>
          <SPADialog.CloseButton />
        </SPADialog.Header>
        <SPADialog.Body>
          <SPADialog.Description>This can&rsquo;t be undone.</SPADialog.Description>
        </SPADialog.Body>
        <SPADialog.Footer>
          <SPADialog.Close asChild>
            <SPAButton>Cancel</SPAButton>
          </SPADialog.Close>
          <SPAButton disabled={isDeleting} variant="danger" onClick={handleConfirm}>Delete note</SPAButton>
        </SPADialog.Footer>
      </SPADialog.Content>
    </SPADialog>
  );
};

export default DeleteNoteButton;
